"use client";

import React from "react";
import styles from "./modular-permissions.module.scss";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import useDelegations from "@/features/mod-perms/hooks/useDelegations";
import useSwitchToBless from "@/features/mod-perms/hooks/useSwitchToBless.hook";
import { useAccount } from "wagmi";
import { motion } from "framer-motion";
import PermissionContextSwitch from "@/features/mod-perms/components/permissions-context-switch";
import OnChainBlock from "@/features/mod-perms/components/permission-blocks/onchain-block";
import MirroredBlock from "@/features/mod-perms/components/permission-blocks/mirrored-block";

const ModularPermissionsPanel: React.FC = () => {
  useSwitchToBless();

  const { getToggledPermissions } = useModularPermissionsStore();
  const { blessnetPermissions, mirroredPermissions } = getToggledPermissions();

  const api = useDelegations();

  const accountStatus = useAccount();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={styles.interfaceWrapper}
    >
      <div className={styles.interfaceContainer}>
        <div className={styles.topSection}>
          <PermissionContextSwitch />
        </div>
        <OnChainBlock
          isLoading={api.isLoading || api.isFetching}
          permissions={blessnetPermissions}
          fetchControls={api}
          connectedAcc={accountStatus}
        />
        <MirroredBlock
          isLoading={api.isLoading || api.isFetching}
          permissions={mirroredPermissions}
          accountStatus={accountStatus}
        />
      </div>
    </motion.div>
  );
};

export default ModularPermissionsPanel;
